import Cookies from 'js-cookie'
import { useCallback, useEffect, useState } from 'react'
import { Button, Card, Form, Modal, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import config from '../../config'
import Select from 'react-select'
import styled from 'styled-components'
import Swal from 'sweetalert2'
import axios from 'axios'

const NUMBER_TYPES = [
  { value: 'pretty', label: 'เลขดี' },
  { value: 'ugly', label: 'เลขเสีย' },
  { value: 'custom', label: 'กำหนดเอง' },
]

const ExtractSeriesModal = ({ isShowExtractSeries, setIsShowExtractSeries }) => {
  const webConfig = useSelector((state) => state.webConfig)
  const roundDate = webConfig.roundDate

  const [isLoadingFetchLotteries, setIsLoadingFetchLotteries] = useState(false)
  const [isLoadingExtractSeries, setIsLoadingExtractSeries] = useState(false)
  const [isPublish, setIsPublish] = useState(false)
  const [lotteriesList, setLotteriesList] = useState([])
  const [lotteryNumber, setLotteryNumber] = useState('......')
  const [selectedLotteries, setSelectedLotteries] = useState(null)
  const [numberType, setNumberType] = useState('pretty')

  const [filteredAllowOptions, setFilteredAllowOptions] = useState([])
  const [amount, setAmount] = useState(0)

  const numberOfSeriesAllowOptions = Array.from({ length: 32 }, (_, i) => ({ key: i + 1, amount: 0 }))

  const fetchLotteries = useCallback(async () => {
    try {
      setIsLoadingFetchLotteries(true)
      const response = await fetch(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/count?roundDate=${roundDate}&isPublish=${isPublish}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      const responseJson = await response.json()

      if (responseJson?.status?.code !== 0) throw new Error(responseJson?.status?.description)

      setLotteriesList(responseJson.data.lottery)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingFetchLotteries(false)
    }
  }, [roundDate, isPublish])

  const extractSeries = async ({ conditions, count, amount, number, isPublish, isUgly }) => {
    try {
      setIsLoadingExtractSeries(true)
      const response = await axios.post(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/extract`,
        {
          conditions,
          count,
          amount,
          number,
          isPublish,
          isUgly,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      return response
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingExtractSeries(false)
    }
  }

  useEffect(() => {
    fetchLotteries()
  }, [fetchLotteries])

  const options = Object.keys(lotteriesList).map((item) => ({
    value: item,
    label: `ชุด: ${item} จำนวน ${lotteriesList[item]} ชุด`,
  }))

  const filteredOptions = options.filter((option) => option.value !== '1' && lotteriesList[option.value] !== '0')

  const totalAmount = filteredAllowOptions.reduce((prev, curr) => prev + curr.amount * curr.key, 0)

  const maxSelectedLottery = selectedLotteries ? Number(lotteriesList[selectedLotteries?.value], 0) : 0

  const handleChangeSwitchPublish = () => {
    setIsPublish((previous) => !previous)
    setLotteryNumber('......')
    setSelectedLotteries(null)
  }

  const handleChangeNumberOfSeries = (data) => {
    setAmount('')
    setSelectedLotteries(data)
    const filteredAllowOptions = numberOfSeriesAllowOptions.filter((option) => {
      return Number(option.key, 0) < Number(data?.value, 0)
    })
    setFilteredAllowOptions(filteredAllowOptions)
  }

  const handleIncrement = (key) => {
    setFilteredAllowOptions((prevOptions) => {
      const index = prevOptions.findIndex((item) => item.key === key)
      const updatedOptions = [...prevOptions]
      updatedOptions[index].amount += 1
      return updatedOptions
    })
  }

  const handleDecrement = (key) => {
    setFilteredAllowOptions((prevOptions) => {
      const index = prevOptions.findIndex((item) => item.key === key)
      const updatedOptions = [...prevOptions]
      updatedOptions[index].amount -= 1
      return updatedOptions
    })
  }

  const handleCloseModal = () => {
    setLotteryNumber('......')
    setIsPublish(false)
    setSelectedLotteries(null)
    setIsShowExtractSeries(false)
  }

  const handleClearForm = () => {
    Swal.fire({
      icon: 'info',
      title: 'ต้องการล้างข้อมูลหรือไม่',
      text: 'ข้อมูลจะถูกล้าง',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setSelectedLotteries(null)
          setLotteryNumber('......')
          setAmount('')
          Swal.fire({
            icon: 'success',
            title: 'ล้างข้อมูลสำเร็จ',
          })
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: error.message,
          })
        }
      }
    })
  }

  const showSuccess = (successCount) => {
    Swal.fire({
      icon: 'success',
      title: 'แยกชุดสำเร็จ',
      text: `แยกชุดสำเร็จ ${successCount} ชุด`,
      confirmButtonText: 'ตกลง',
    }).then(() => {
      setSelectedLotteries(null)
      setLotteryNumber('......')
      setAmount('')
    })
  }

  const showError = (error) => {
    Swal.fire({
      icon: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: error ?? 'เกิดข้อผิดพลาด',
    })
  }

  const handleSubmitForm = async () => {
    const count = Number(selectedLotteries?.value, 0)

    if (totalAmount < count) return alert('จำนวนชุดที่ต้องการแยกไม่เท่ากับจำนวนชุดที่เลือก')
    if (Number(amount) < 1) return alert('กรุณากรอกจำนวนชุดที่ต้องการแยก')

    const conditions = filteredAllowOptions.reduce((prev, curr) => {
      if (curr.amount !== 0) {
        prev[curr.key] = curr.amount
      }
      return prev
    }, {})

    const number = lotteryNumber.split('').every((item) => item === '.') ? '' : lotteryNumber

    if (amount >= 5000 && !isPublish) {
      let successCount = 0
      const total = Math.min(Number(amount), maxSelectedLottery)
      let remaining = total

      while (remaining > 0) {
        const chunk = remaining > 5000 ? 5000 : remaining
        try {
          const response = await extractSeries({
            conditions,
            count,
            amount: chunk,
            number: numberType === 'custom' ? number : '',
            isPublish,
            ...(numberType !== 'custom' && { isUgly: numberType === 'ugly' }),
          })
          if (response?.data?.status?.code !== 0) {
            throw new Error(response?.data?.status?.description)
          }
          successCount += Number(response?.data?.data.count)
        } catch (error) {
          showError(error?.message)
        }
        remaining -= chunk
      }

      if (successCount > 0) {
        showSuccess(successCount)
      }
      return
    } else {
      try {
        const response = await extractSeries({
          conditions,
          count,
          amount: Number(amount),
          number: numberType === 'custom' ? number : '',
          isPublish,
          ...(numberType !== 'custom' && { isUgly: numberType === 'ugly' }),
        })

        if (response?.data?.status?.code !== 0) {
          throw new Error(response?.data?.status?.description)
        }
        showSuccess(response?.data?.data?.success)
      } catch (error) {
        showError(error)
      }
    }
  }

  return (
    <Modal show={isShowExtractSeries} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>แยกชุด</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <YStack>
          <YStack>
            <Title>เลือกประเภท</Title>
            <XStack>
              <Button
                variant={isPublish ? 'primary' : 'dark'}
                style={{ opacity: 1 }}
                size="sm"
                disabled={isPublish}
                onClick={handleChangeSwitchPublish}
              >
                Public
              </Button>
              <Button
                variant={!isPublish ? 'primary' : 'dark'}
                style={{ opacity: 1 }}
                size="sm"
                disabled={!isPublish}
                onClick={handleChangeSwitchPublish}
              >
                Temp
              </Button>
            </XStack>
          </YStack>
          <YStack>
            <Title>เลือกชุดที่ต้องการแยก</Title>
            {isLoadingFetchLotteries ? (
              <LoadingText>กำลังโหลด...</LoadingText>
            ) : (
              <Select value={selectedLotteries} onChange={handleChangeNumberOfSeries} options={filteredOptions} />
            )}
          </YStack>
          {selectedLotteries && (
            <>
              <YStack>
                <Title>กำหนดขนาดที่ต้องการแยก (ผลรวมไม่เกิน {selectedLotteries?.value})</Title>
                <Row>
                  {filteredAllowOptions.map(({ key, amount }) => {
                    return (
                      <Card className="ml-2" key={`filteredAllowOptions-${key}`}>
                        <Card.Body>
                          <CardContainer>
                            <CardInfoText>ชุด {key}</CardInfoText>
                            <CardInfoText>จำนวน {amount}</CardInfoText>
                            <XStack>
                              <ButtonDecrement
                                variant="danger"
                                disabled={amount === 0}
                                onClick={() => handleDecrement(key)}
                              >
                                -
                              </ButtonDecrement>
                              <ButtonIncrement
                                variant="success"
                                disabled={totalAmount + key > Number(selectedLotteries?.value, 0)}
                                onClick={() => handleIncrement(key)}
                              >
                                +
                              </ButtonIncrement>
                            </XStack>
                          </CardContainer>
                        </Card.Body>
                      </Card>
                    )
                  })}
                </Row>
              </YStack>
              <XStack>
                {NUMBER_TYPES.map(({ value, label }) => {
                  return (
                    <Form.Check
                      key={value}
                      value={value}
                      label={label}
                      type="radio"
                      onChange={(e) => setNumberType(e.target.value)}
                      checked={numberType === value}
                    />
                  )
                })}
              </XStack>
              {numberType === 'custom' && (
                <YStack>
                  <Title>เลขที่ต้องการแยก</Title>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '4px',
                    }}
                  >
                    {lotteryNumber.split('').map((number, index) => (
                      <Form.Control
                        key={index}
                        id={`lotteryNumber${index}`}
                        maxLength={1}
                        value={number.replace('.', '')}
                        style={{
                          height: '64px',
                          width: '64px',
                          textAlign: 'center',
                        }}
                        onKeyDown={(e) => {
                          if (e.target.value !== '') return
                          if (e.key === 'Backspace') {
                            const previousInput = document.querySelector(`#lotteryNumber${index - 1}`)
                            previousInput && previousInput.focus()
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value

                          if (value !== '' && !/^[0-9\s]/g.test(value)) return

                          setLotteryNumber((number) => {
                            const newNumber = number.split('')
                            newNumber[index] = value || '.'
                            return newNumber.join('')
                          })

                          if (e.nativeEvent.inputType === 'insertText') {
                            if (lotteryNumber.length + 1 === index) return

                            const nextInput = document.querySelector(`#lotteryNumber${index + 1}`)
                            nextInput && nextInput.focus()
                          }
                        }}
                      />
                    ))}
                  </div>
                </YStack>
              )}
              <YStack>
                <Title>กำหนดจำนวนชุดที่ต้องการแยก</Title>
                <Row>
                  <Form.Control
                    type="number"
                    placeholder="จำนวนชุดที่ต้องการแยก"
                    value={amount}
                    onKeyDown={(e) => {
                      setAmount(e.target.value)
                    }}
                    onBlur={(e) => {
                      const value = Number(e.target.value)
                      const maxLength = isPublish ? 5000 : 20000

                      if (e.target.value === '') return

                      if (value < 1) {
                        Swal.fire({
                          icon: 'error',
                          title: 'จำนวนที่ต้องการแยก',
                          text: 'จำนวนชุดที่ต้องการแยกต้องมากกว่า 0',
                        })
                        setAmount(1)
                        return
                      }

                      if (value > maxSelectedLottery || value > maxLength) {
                        const finalLimit = Math.min(maxSelectedLottery, maxLength)
                        setAmount(finalLimit)

                        const isLotteryLimitExceeded = value > maxSelectedLottery
                        const isMaxLengthExceeded = value > maxLength

                        let errorMessage = ''
                        if (isLotteryLimitExceeded && isMaxLengthExceeded) {
                          errorMessage =
                            maxSelectedLottery < maxLength
                              ? `ต้องไม่เกินจำนวนชุดที่เลือก ${maxSelectedLottery} ชุด`
                              : `ต้องไม่เกินลิมิต (${maxLength} ชุด)`
                        } else if (isLotteryLimitExceeded) {
                          errorMessage = `ต้องไม่เกินจำนวนชุดที่เลือก ${maxSelectedLottery} ชุด`
                        } else {
                          errorMessage = `ต้องไม่เกินลิมิต ${maxLength} ชุด`
                        }

                        Swal.fire({
                          icon: 'error',
                          title: 'จำนวนที่ต้องการแยก',
                          text: errorMessage,
                        })
                        return
                      }

                      setAmount(value)
                    }}
                    onChange={(e) => setAmount(e.target.value)}
                    min={1}
                    max={maxSelectedLottery}
                    disabled={totalAmount !== Number(selectedLotteries?.value)}
                  />
                </Row>
              </YStack>
            </>
          )}
        </YStack>
      </Modal.Body>
      <Modal.Footer>
        <XStack>
          <Button size="sm" variant="danger" onClick={handleClearForm} disabled={selectedLotteries === null}>
            ล้างข้อมูล
          </Button>
          <Button size="sm" onClick={handleSubmitForm} disabled={isLoadingExtractSeries || amount > maxSelectedLottery}>
            {isLoadingExtractSeries ? 'กำลังอัพเดท' : 'แยกชุด'}
          </Button>
        </XStack>
      </Modal.Footer>
    </Modal>
  )
}

export default ExtractSeriesModal

const XStack = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`

const YStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

const CardInfoText = styled.div`
  text-align: center;
  text-size: 16px;
  font-weight: 700;
  color: #000000;
  min-width: 100px;
`

const ButtonIncrement = styled(Button)`
  width: 32px;
  height: 32px;
  padding: 0px;
  border-radius: 64px;
  border: 0px;
`

const ButtonDecrement = styled(Button)`
  width: 32px;
  height: 32px;
  padding: 0px;
  border: 0px;
`

const Title = styled.div`
  font-weight: 700;
`

const LoadingText = styled.div`
  font-size: 16px;
  font-weight: 500;
`
